module.exports = __webpack_public_path__ + "static/media/12.017dd207.jpg";